<template lang="pug">
    Authenticate(defaultTab="register" :registration="registration")
        .contentpage
            validation-observer(v-slot="{ invalid }" ref="form")
                form(@submit.prevent="submit")
                    .section(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
                        .container.content(v-if="section.key === 'heading'")
                            .column.is-offset-1.is-10
                                .field
                                    select-with-validation.select-field(
                                        rules="required"
                                        name="Toolfamilie"
                                        v-model="tag"
                                        :options="tags"
                                        :multiple="false"
                                        :allow-empty="true"
                                        :show-labels="true"
                                        placeholder="bitte wählen..."
                                        deselect-label="mit Enter abwählen"
                                        selected-label="ausgewählt"
                                        select-label="mit Enter auswählen"
                                    )
                        .container.content(v-if="section.key === 'heading'")
                            .column.is-offset-1.is-10
                                .field
                                    validation-provider(name="URL" rules="required|url" v-slot="{ errors }")
                                        label.label URL (Website) zur Anwendung
                                        input.input(
                                            type="text"
                                            v-model="hyperlink"
                                            :class="{ 'is-danger': errors && errors.length }"
                                        )
                                        p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                        p.help.has-text-grey(v-else) Pflicht 
                                        p.help.has-text-grey Die Url muss mit http:// oder https:// beginnen
                        Heading(
                            v-if="section.key === 'heading'"
                            :section="section"
                            :edit="true"
                            heading-field-name="Überschrift"
                            heading-rules="required"
                            sub-heading-field-name="Thema"
                            sub-heading-rules="required"
                            @change="updateSectionContent"

                        )
                        .container.content(v-if="section.key === 'heading'")
                            .column.is-offset-1.is-10
                                .field
                                    validation-provider(name="Bewertung" rules="required" v-slot="{ errors }")
                                        label.label Bewerten Sie bitte Ihre genutzte Anwendung
                                        StarRating(
                                            v-model="rating"
                                            :increment="1"
                                            :read-only="false"
                                            :show-rating="false"
                                            :max-rating="stars"
                                            :star-size="20"
                                        )
                                        p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                        p.help.has-text-grey(v-else) Pflicht
                        .container.content(v-if="section.key === 'image'")
                            .column.is-offset-1.is-10
                                ImageSection(
                                    :section="section"
                                    :edit="true"
                                    name="Screenshot"
                                    rules="required"
                                    @change="updateSectionImage"
                                )
                        Description(
                            v-if="section.key === 'service-description'"
                            :section="section"
                            :edit="true"
                            name="Beschreibung"
                            rules="required"
                            @change="updateSectionContent"
                        )
                        PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section" :edit="true" @change="updateSectionImage")
                    .section
                        .container
                            .column.is-offset-1.is-10
                                button.button.is-primary(
                                    :disabled="invalid || saving"
                                    :class="{ 'is-loading': saving }"
                                ) Speichern
</template>

<script>

import _ from 'lodash'
import Vue from 'vue'
import uniqid from 'uniqid'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
// import Multiselect from 'vue-multiselect'

import router from '@/router'

import Authenticate from '@/components/Authenticate'
import Heading from '@/components/Heading'
import PhotoAlbum from '@/components/PhotoAlbum'
import ImageSection from '@/components/ImageSection'
import Description from '@/components/Description'
import SelectWithValidation from '@/components/Partials/SelectWithValidation'

export default {
    name: 'ServicePageForm',
    data() {
        return {
            saving: false,
            tag: null,
            tags: [
                'Wiki',
                'Online-Seminar',
                'Konferenz',
                'Blog',
                'Screencast',
                'Pad',
                'Umfragetool',
                'Lehrvideo',
                'Forum',
                'Chat',
                'Messenger',
                'Dateiablage',
                'Podcast',
                'Game',
                'Quiz',
                'Microblog',
                'Simulation',
                'Augmented Reality',
                'Virtual Reality',
                'Geocaching',
                'Whiteboard',
                'Visualizer',
                'Präsentation',
                'Mindmap',
                'Virtual Classroom',
                'MOOC',
                'Sonstiges'
            ],
            stars: 5,
            rating: undefined,
            sections: [
                {
                    id: uniqid('new:'),
                    key: 'heading',
                    name: 'Überschrift',
                    position: 1,
                    contents: [{
                        id: uniqid('new:'),
                        key: 'heading',
                        title: '',
                        sub_title: null,
                        labels: {
                            title: 'Name Ihrer genutzten Anwendung plus Versionsnummer',
                            // sub_title: 'Toolfamilie (z.B. Umfragetool)',
                        }
                    }],
                }, {
                    id: uniqid('new:'),
                    key: 'image',
                    name: 'Bild',
                    position: 2,
                    labels: {
                        title: 'Screenshot der Anwendung hochladen',
                        sub_title: '<span class="href">hierher ziehen</span> oder <span class="href">hier klicken</span>',
                    }
                    // contents: [{
                    //     id: uniqid('new:'),
                    //     key: 'image',
                    //     title: '',
                    //     sub_title: null,
                    //     images: [],
                    // }],
                }, {
                    id: uniqid('new:'),
                    key: 'service-description',
                    name: 'Beschreibung',
                    position: 3,
                    contents: [{
                        id: uniqid('new:'),
                        key: 'content',
                        text: '',
                        hyperlink: {
                            id: uniqid('new:'),
                            href: '',
                            name: '',
                            type: 'external',
                            target: '_blank',
                        },
                        labels: {
                            text: `
                                <p>Beschreiben Sie bitte den Praxiseinsatz. Ihr Text sollte folgende Fragen beantworten:</p>
                                <ul>
                                    <li>Wofür/ in welchem Zusammenhang wurde die Anwendung genutzt?</li>
                                    <li>Was war die Intention/ die Absicht des Einsatzes der Anwendung?</li>
                                    <li>Welche Möglichkeiten bietet die Anwendung?</li>
                                    <li>Welche Grenzen hat die Anwendung?</li>
                                </ul>
                                <br>
                            `
                        }
                    }],
                }, {
                    id: uniqid('new:'),
                    key: 'photoalbum',
                    name: 'Fotoalbum',
                    position: 4,
                    labels: {
                        title: 'Weitere Screenshots der Anwendung hochladen (optional)',
                        sub_title: '<span class="href">hierher ziehen</span> oder <span class="href">hier klicken</span>',
                    },
                    contents: [],
                },
            ],
        }
    },
    components: {
        Authenticate,
        // Multiselect,
        Heading,
        PhotoAlbum,
        ImageSection,
        Description,
        // Multiselect,
        ValidationObserver,
        ValidationProvider,
        SelectWithValidation,
    },
    computed: {
        category() {
            return _.get(this.$route, 'meta.category.key')
        },
        hyperlink: {
            get() {
                let section, content

                section = this.sections.find(section => section.key === 'service-description')
                if (section && section.contents) {
                    content = section.contents.find(content => content.key === 'content')
                }

                return content.hyperlink.href
            },
            set(value) {
                let section, content

                section = this.sections.find(section => section.key === 'service-description')
                if (section && section.contents) {
                    content = section.contents.find(content => content.key === 'content')
                }

                if (content) {
                    content.hyperlink.href = value
                }
            }
        },
        registration() {
            return _.get(this.evaluation, 'finished', false)
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            evaluation: 'currentPage/evaluation',
            member: 'auth/member',
            cms: 'CMS',
        })
    },
    methods: {
        updateSectionContent(sID, cID, field, value) {
            let section, content
            section = this.sections.find(section => section.id === sID)
            if (section && section.contents) {
                content = section.contents.find(content => content.id === cID)
            }

            if (content && field) {
                content[field] = value
                // Vue.set(this.sections.heading.contents[0], field, value)
            }

            if (section.key === 'heading' && content.key === 'heading' && field === 'title') {
                let section, content

                section = this.sections.find(section => section.key === 'service-description')
                if (section && section.contents) {
                    content = section.contents.find(content => content.key === 'content')
                }

                if (content) {
                    content.hyperlink.name = value
                }
            }
        },
        updateSectionImage(sID, cID, image, action = 'add') {
            let s, c
            let section, content

            s = _.findIndex(this.sections, { id: sID })
            if (s >= 0) section = this.sections[s]
            if (section && section.contents) {
                c = _.findIndex(section.contents, { id: cID })
                if (c >= 0) content = section.contents[c]
            }

            if (! content && action === 'add') {
                content = {
                    id: uniqid('new:'),
                    key: 'image',
                    title: '',
                    sub_title: null,
                    images: [],
                }
            }

            if (section && content) {
                switch (action) {
                    case 'add':
                        if (c >= 0) {
                            const i = this.sections[s].contents[c].images.length
                            Vue.set(this.sections[s].contents[c].images, i, image)
                        } else if (! this.sections[s].contents || ! this.sections[s].contents.length) {
                            content.images.push(image)
                            Vue.set(this.sections[s], 'contents', [content])
                        } else {
                            c = this.sections[s].contents.length
                            content.images.push(image)
                            Vue.set(this.sections[s].contents, c, content)
                        }
                        break;

                    case 'delete':
                        const i = _.findIndex(this.sections[s].contents[c].images, { id: image.id })
                        if (i >= 0) Vue.delete(this.sections[s].contents[c].images, i)
                        if (! this.sections[s].contents[c].images.length) Vue.delete(this.sections[s].contents, c)
                        break;
                }
            }
        },
        redirect() {
            const route = '/digitale-werkzeuge'
            router.push(route)
        },
        async submit() {
            this.saving = true

            const valid = await this.$refs.form.validate()
            if (valid && this.recaptchaSiteKey) {
                await this.$recaptchaLoaded()
                try {
                    const token = await this.$recaptcha('auth')

                    let title
                    let sections = [{
                        id: uniqid('new:'),
                        area: "teaser",
                        key: 'category-page-teaser',
                        name: 'Anreißer',
                        position: -1,
                        contents: [{
                            id: uniqid('new:'),
                            key: 'teaser',
                            text: '',
                        }],
                    }]
                    this.sections.forEach(el => {
                        if (el.key === 'heading') title = el.contents[0].title
                        let section = {
                            id: el.id,
                            key: el.key,
                            name: el.name,
                            position: el.position,
                            contents: [],
                        }
                        _.get(el, 'contents', []).forEach(co => {
                            let content = {
                                id: co.id,
                                key: co.key,
                                name: co.name,
                                position: co.position,
                                title: co.title,
                                sub_title: co.sub_title,
                                text: co.text,
                                hyperlink: co.hyperlink,
                                images: co.images,
                            }

                            if (el.key === 'heading' && co.key === 'heading') content.sub_title = this.tag
                            section.contents.push(content)
                        })
                        sections.push(section)
                    })
                    let page = {
                        key: '', // generate slug server side
                        title,
                        view: 'ServicePage',
                        category: {
                            key: 'digitale-werkzeuge',
                        },
                        sections,
                        comments: [{
                            id: uniqid('new:'),
                            username: this.member.name,
                            email: this.member.email,
                            rating: this.rating * ( 100 / this.stars ),
                        }],
                        evaluations: [{
                            id: uniqid('new:'),
                            data: JSON.stringify(this.evaluation.informations),
                        }],
                        tags: [{
                            name: this.tag
                        }]
                    }
                    this.create(page)
                        .then(() => {
                            this.addMessage({
                                id: _.uniqueId(),
                                title: 'Erfolg',
                                text: 'Der Beitrag wurde erfolgreich gespeichert.',
                                type: 'success',
                                autoclose: 5000
                            });
                            this.redirect()
                        })
                        .catch(() => {
                            this.addMessage({
                                id: _.uniqueId(),
                                title: 'Fehler',
                                text: 'Der Beitrag konnte nicht gespeichert werden.',
                                type: 'danger',
                                autoclose: 5000
                            });
                        })
                        .finally(() => {
                            this.saving = false
                        })

                } catch (error) {
                    this.addMessage({
                        id: _.uniqueId(),
                        title: 'Es gibt ein technisches Problem.',
                        text: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                        type: 'danger',
                        autoclose: 5000
                    });
                    this.saving = false
                }
            } else {
                // TODO
                // submit without recaptcha ?

                this.addMessage({
                    id: _.uniqueId(),
                    title: 'Es gibt ein technisches Problem.',
                    text: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'danger',
                    autoclose: 5000
                });
                this.saving = false
            }
        },
        ...mapMutations({
            addMessage: 'addMessage',
        }),
        ...mapActions({
            create: 'currentPage/create'
        }),
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, { siteKey: this.recaptchaSiteKey })
        }
    }
}

</script>

<style lang="sass" scoped>
    @import "@/assets/sass/variables.sass";
    @import "~bulma/sass/utilities/mixins";

    .heading
        label.label, .multiselect
            letter-spacing: initial
    .section /deep/ .ql-editor
        min-height: 240px
    // .button
    //     background-color: $primary
    //     color: #fff
    //     margin-bottom: 25px
    //     &:hover
    //         color: #fff
</style>
